export default "__VITE_ASSET__Dhdg85kM__"